import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  useTheme,
} from "@mui/material";
import gif1 from "./img/card1.gif";
import gif2 from "./img/card2.gif";

const CardsMenu = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #c5e3f5 0%, #ddeffa 100%)",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          py: { xs: 5, md: 10 },
          px: { xs: 2, md: 8 },
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
        }}
      >
        <Typography
          variant="h2"
          component="h2"
          textAlign="center"
          mb={1}
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "2rem", md: "3rem" },
            lineHeight: 1.3,
          }}
        >
          WhatsApp Payment Features
          <br />
          <span style={{ color: "#044d91" }}>(Vertex Suite Exclusive)</span>
        </Typography>
        <Typography
          variant="h5"
          textAlign="center"
          color="text.secondary"
          mb={6}
          sx={{
            mt: 3,
            fontSize: { xs: "1.2rem", md: "1.5rem" },
          }}
        >
          WhatsApp Payments enables end-to-end shopping experience right on
          WhatsApp.
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {/* Card 1 */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                p: 2,
                borderRadius: 3,
                height: "100%",
                boxShadow: 3,
                backgroundColor: "#ffffff",
                transition: 'transform 0.3s ease-out',
                '&:hover': {
                    transform: 'translateY(-5px)',
                    cursor: 'pointer',
                }
              }}
            >
              <CardContent>
                <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                  Send Payment messages via Live Chat &{" "}
                  <Box component="span" color="#00C853">
                    Chatbot Flows
                  </Box>
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={3}
                  fontSize={"1rem"}
                >
                  Not only can you broadcast payment messages to all users, but
                  you can also shoot payment messages to individual users
                  directly from Live Chat & chatbot flows.
                </Typography>
              </CardContent>
              <CardMedia
                component="img"
                image={gif1}
                alt="Chatbot Flow"
                sx={{
                  width: "100%",
                  height: "auto",
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              />
            </Card>
          </Grid>

          {/* Card 2 */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                p: 2,
                borderRadius: 3,
                height: "100%",
                boxShadow: 3,
                backgroundColor: "#ffffff",
                transition: 'transform 0.3s ease-out',
                '&:hover': {
                    transform: 'translateY(-5px)',
                    cursor: 'pointer',
                }
              }}
            >
              <CardContent>
                <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                  Track Payment Status &{" "}
                  <Box component="span" color="#00C853">
                    Retarget
                  </Box>{" "}
                  Effortlessly
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={3}
                  fontSize={"1rem"}
                >
                  Monitor pending & successful payments in a campaign and
                  further send retargeting campaigns to users who failed to
                  complete the payment.
                </Typography>
              </CardContent>
              <CardMedia
                component="img"
                image={gif2}
                alt="Retargeting"
                sx={{
                  width: "100%",
                  height: "auto",
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              />
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default CardsMenu;
